import { Facility } from '@intelligent-play-v2/domain';
import { compareDesc } from 'date-fns';
import { getFacilityLiveDate } from './getLiveDate';

export const compareFacilitiesByName = (
  facilityA: Facility,
  facilityB: Facility,
  isAsc: boolean
): number => {
  const nameA = facilityA.name?.toUpperCase() ?? '';
  const nameB = facilityB.name?.toUpperCase() ?? '';
  if (isAsc) {
    return nameA < nameB ? -1 : 1;
  } else {
    return nameA > nameB ? -1 : 1;
  }
};

export const compareFacilitiesByDateAdded = (
  facilityA: Facility,
  facilityB: Facility
): number =>
  compareDesc(getFacilityLiveDate(facilityA), getFacilityLiveDate(facilityB));
